import { useTranslation } from 'react-i18next';

import { Window } from 'components/shared/window/window';
import { Signals } from './signals/signals';
import SignalsHistory from './signals-history/signals-history';
import { Options } from './options/options';
import { OptionsApp } from './options/options-app';
import { OptionsCashbox } from './options/options-cashbox';
import { ScheduleOptions } from './options/options-schedule';

import RackControl from './controls/rack/rack';
import AppControl from './controls/app/app';
import GooseControl from './controls/goose/goose';

export const RackWindow = (props) => {
  const scale = props.scale ?? 1;
  const { t } = useTranslation();
  const type = props.data.data.type;
  const tabs = [];
  const withoutRack = ['server', 'cashbox'].includes(type);
  if (!withoutRack) {
    tabs.push({ text: t('windows.Управление'), id: 'control' });
  }
  tabs.push({ text: t('windows.Сигналы'), id: 'signals' });
  tabs.push({ text: t('windows.История сигналов'), id: 'history' });
  if (window.haveRight('mnemo.rack_settings') && !['goose', 'server'].includes(props.data.data.type)) {
    tabs.push({ text: t('windows.Настройки'), id: 'options' });
  }
  if (window.haveRight('schedule_of_modes') && !['goose', 'server', 'payment_terminal', 'cashbox'].includes(props.data.data.type)) {
    tabs.push({ text: t('windows.Расписание работы'), id: 'schedule' });
  }

  const activeTab = props.data.data.withSignals ? 'signals' : '';

  const getRackControlByType = () => {
    switch (props.data.data.type) {
      case 'single_rack':
        return RackControl;
      case 'payment_terminal':
        return AppControl;
      case 'goose':
        return GooseControl;
      case 'server':
      case 'cashbox':
        return null;
      default:
        return RackControl;
    }
  };

  const content = {
    control: getRackControlByType(),
    signals: Signals,
    history: SignalsHistory,
    options: props.data.data.type === 'cashbox' ? OptionsCashbox : props.data.data.type === 'payment_terminal' ? OptionsApp : Options,
    schedule: ScheduleOptions,
  };

  const height = props.data.data.type === 'payment_terminal' ? '740px' : '700px';

  return (
    <Window
      withMode
      activeTab={activeTab}
      type={type}
      tabs={tabs}
      content={content}
      width="990px"
      height={height}
      contentHeight={height}
      scale={scale}
      {...props.data}
    />
  );
};
